import { ElementState, Preview } from "@creatomate/preview";
import { Subtitle, SubtitleSection } from "chq";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";

const trimSections = async (
  preview: Preview,
  placement: { time: number; duration: number },
  subtitle: Subtitle,
  videoEndTime: number,
  trimFieldValue: boolean,
  videos?: ElementState[]
): Promise<{ newModifications: Record<string, any>; sections: SubtitleSection[] }> => {
  const subtitlesSections = subtitle.sections || [];
  const sections: SubtitleSection[] = [];
  let modifications = {};
  for (let sectionIndex = 0; sectionIndex < subtitlesSections.length; sectionIndex += 1) {
    const section = subtitlesSections[sectionIndex];
    if (placement.time < section.endTime && section.startTime < videoEndTime) {
      if (trimFieldValue) {
        modifications = {
          ...modifications,
          [`${section.creatomateId}.time`]: Math.max(section.startTime - placement.time, 0)
        };
      }
      sections.push({ ...section });
    } else if (videos?.some(vid => (
      vid.globalTime <= section.startTime && (vid.globalTime + vid.duration) >= section.endTime
    ))) {
      // if the subtitle belongs to another video section
      sections.push({ ...section });
    } else if (subtitle.active && section.creatomateId) {
      sections.push({
        ...section,
        hidden: true
      });

      // eslint-disable-next-line no-await-in-loop
      await deleteElement(preview, section.creatomateId);
    }
  }
  return { newModifications: modifications, sections };
};

const trimSubtitles = async (
  subtitles: Subtitle[],
  placement: { time: number; duration: number },
  preview: Preview,
  handleUpdateData: (newData: Record<string, any>) => void,
  videos?: ElementState[],
  trimFieldValue = false
): Promise<Record<string, any>> => {
  let modifications = {};
  const videoEndTime = placement.time + placement.duration;
  const updatedSubtitles: Subtitle[] = await Promise.all(
    subtitles.map(async subtitle => {
      const { newModifications, sections } = await trimSections(
        preview, placement, subtitle, videoEndTime, trimFieldValue, videos
      );
      modifications = { ...modifications, ...newModifications };
      return { ...subtitle, sections };
    })
  );
  handleUpdateData({ subtitles: updatedSubtitles });
  return modifications;
};

export default trimSubtitles;
